// @flow

/**
 * Triggers `resizeEnd` after resize events had ended.
 */

export default (props: ?any) => {
	const DEBUG = false;
	const timeLimit = 300;
	let resizeTimeout;
	let resizeEnd;

	window.addEventListener('resize', (e) => {
		if ( DEBUG ) console.log(e);
		if ( resizeTimeout ) clearTimeout(resizeTimeout);
		resizeEnd = new UIEvent('resizeEnd', { bubbles: true, cancelable: true });
		if ( DEBUG ) console.log(resizeEnd);
		resizeTimeout = setTimeout(() => window.dispatchEvent(resizeEnd), timeLimit);
	});

	// debug
	window.addEventListener('resizeEnd', (e) => {
		if ( DEBUG ) console.log('resizeEnd triggered', e);
	});

};



// WEBPACK FOOTER //
// ./config/fe/web-default/src/js/webActions/resizeEndEvent.js